import { render, staticRenderFns } from "./feeVouchers.vue?vue&type=template&id=aff68634&scoped=true"
import script from "./feeVouchers.vue?vue&type=script&lang=js"
export * from "./feeVouchers.vue?vue&type=script&lang=js"
import style0 from "./feeVouchers.vue?vue&type=style&index=0&id=aff68634&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff68634",
  null
  
)

export default component.exports